import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPublicSiteMarketingConfig } from '../utils/publicSiteConfig';
import { buildPublicEventNavPaths } from '../utils/publicEventNav';
import './PublicEventChrome.css';

/** Served from `public/FM logo ORANGE TR BG.png` */
const PUBLIC_HEADER_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/FM%20logo%20ORANGE%20TR%20BG.png`;

/**
 * Shared thin header for public event pages (schedule, leaderboard) on the app host.
 * @param {{ activeNav: 'schedule' | 'leaderboard' | 'prizes' | 'marketing', eventQueryId?: string, editionYearParam?: string|null, editionYearFallback?: string|number|null }} props
 */
function PublicEventChrome({
  activeNav,
  eventQueryId = '',
  editionYearParam = null,
  editionYearFallback = null,
}) {
  const [marketingHomeUrl, setMarketingHomeUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    getPublicSiteMarketingConfig().then((cfg) => {
      if (!cancelled) setMarketingHomeUrl(cfg.marketingSiteBaseUrl || '');
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const homeHref = marketingHomeUrl || '/';
  const paths = buildPublicEventNavPaths({ eventQueryId, editionYearParam, editionYearFallback });

  return (
    <header className="public-event-chrome" role="banner">
      <div className="public-event-chrome__inner">
        <a href={homeHref} className="public-event-chrome__logo-link" aria-label="Fresh Meet home (main site)">
          <img
            src={PUBLIC_HEADER_LOGO_SRC}
            alt=""
            className="public-event-chrome__logo"
            height={44}
            decoding="async"
          />
        </a>
        <nav className="public-event-chrome__nav" aria-label="Event pages">
          <Link
            to={paths.schedule}
            className={`public-event-chrome__link${activeNav === 'schedule' ? ' public-event-chrome__link--active' : ''}`}
          >
            Schedule
          </Link>
          <Link
            to={paths.liveHub}
            className="public-event-chrome__link"
            title="Back to puzzles, clues, and event home"
          >
            Live hub
          </Link>
          <Link
            to={paths.leaderboard}
            className={`public-event-chrome__link${activeNav === 'leaderboard' ? ' public-event-chrome__link--active' : ''}`}
          >
            Leaderboard
          </Link>
          <Link
            to={paths.prizes}
            className={`public-event-chrome__link${activeNav === 'prizes' ? ' public-event-chrome__link--active' : ''}`}
          >
            What can I win?
          </Link>
          <a
            href={homeHref}
            className={`public-event-chrome__link${activeNav === 'marketing' ? ' public-event-chrome__link--active' : ''}`}
          >
            Main Site
          </a>
        </nav>
      </div>
    </header>
  );
}

export default PublicEventChrome;
